import { usePreQualContext } from "pages/PreQualification/PreQualification";
import { HEALTH_APP_RESULTS } from "pages/PreQualification/utils/constants";
import { CoverageEligibility } from "types/CoverageEligibility";
import { useUpdateStepMutation } from "types/generated/operations";
import FooterButton from "uicomponents/FooterButton";
import { trackFormSubmission } from "utils/analytics/trackEvent";
import { getStepNumberFromURL } from "utils/helper";
import styles from "../Results.module.css";

interface IResultPageSuccessProps {
  data: CoverageEligibility;
}
const ResultPageSuccessModel = ({
  data,
}: IResultPageSuccessProps): JSX.Element => {
  const { previousStep, nextStep } = usePreQualContext();
  const currentStep = getStepNumberFromURL();
  const [updateStep, { loading: updateStepLoading }] = useUpdateStepMutation();

  const handleNextClick = async () => {
    try {
      if (data?.applications?.[0]?.step === currentStep) {
        await updateStep({
          variables: {
            uuid: data?.applications?.[0].uuid,
            step: data?.applications?.[0]?.step + 1,
          },
        });
        trackFormSubmission(3, "PreQual");
      }
      nextStep();
    } catch (error: any) {
      console.log("error updating step", error);
      return;
    }
  };
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{HEALTH_APP_RESULTS.SUCCESS.title}</h3>

      <p>{HEALTH_APP_RESULTS.SUCCESS.content}</p>

      <FooterButton
        nextButtonText={
          updateStepLoading
            ? HEALTH_APP_RESULTS.SUCCESS.loadingButtonText
            : HEALTH_APP_RESULTS.SUCCESS.nextButtonText
        }
        backButtonText={HEALTH_APP_RESULTS.SUCCESS.backButtonText}
        handleBackClick={previousStep}
        handleNextClick={handleNextClick}
        disabled={updateStepLoading}
      />
    </div>
  );
};

export default ResultPageSuccessModel;
